import { getTrimLeadingZerosFlag } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';
import { isEmpty } from 'lodash';

export const useTrimLeadingZerosFeature = (
  tenantId: string,
  enabled = true
) => {
  const { data, status, refetch } = useQuery(
    ['trim-leading-zeros-feature'],
    () => getTrimLeadingZerosFlag(tenantId),
    {
      enabled: enabled && !isEmpty(tenantId),
    }
  );

  return {
    feature: data,
    featureStatus: status,
    fetchFeature: refetch,
  };
};
